var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shelve)?_c('v-container',{attrs:{"id":"rewards","fluid":"","tag":"section"}},_vm._l((_vm.shelve.shelfs),function(shelf,i){return _c('shelf-component',{key:("shelf-" + i),attrs:{"shelfIndex":i}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }